<h2 mat-dialog-title>OpenAI Integration Settings</h2>
<mat-dialog-content style="margin: 12px 24px">
    <form [formGroup]="openAiSettingForm">
        <mat-form-field style="width:100%; padding-bottom: 20px">
            <mat-label>API Key</mat-label>
            <input matInput placeholder="Enter your API key..." formControlName="apiKey" />
            <mat-hint class="input-hint">For more information about API key, see <a href="https://sites.google.com/a/ediscoveryplatform.com/help/home/help/management-menu/third-party-applications" target="_blank">Help Page</a></mat-hint>
        </mat-form-field>
        <mat-form-field style="width:100%">
            <mat-label>API Model</mat-label>
            <mat-select formControlName="apiModel">
                <mat-option *ngFor="let model of models" [value]="model.value" [ngClass]="{'dark-theme-option dark-theme': isDarkMode()}">
                    {{model.name}}
                </mat-option>
            </mat-select>
            <mat-hint class="input-hint">For more information on OpenAI models, see <a href="https://sites.google.com/a/ediscoveryplatform.com/help/home/help/document-viewer/smart-tab" target="_blank">Smart Tab Insights</a></mat-hint>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch flex-start; align-items: stretch;">
        <button mat-button color="primary" *ngIf="isLinked" (click)="unlink()">Unlink</button>
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch flex-end; align-items: stretch;">
        <button mat-raised-button color="primary" *ngIf="!isLinked" (click)="link()">Link</button>
        <button mat-raised-button color="primary" *ngIf="isLinked" [disabled]="openAiSettingForm.invalid || !(openAiSettingForm.controls['apiKey'].dirty || openAiSettingForm.controls['apiModel'].dirty)" (click)="submit()">Update</button>
        <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
    </div>
</mat-dialog-actions>